import React, { Component, ErrorInfo } from 'react';

interface Props {
  children: React.ReactNode;
  pageName?: string;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class PageErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error(`[PageErrorBoundary] ${this.props.pageName ?? 'Page'} crashed:`, error, info);
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return (
        <div className="page-error" role="alert">
          <h2>Something went wrong</h2>
          <p>
            {this.props.pageName
              ? `We hit an unexpected error loading ${this.props.pageName}.`
              : 'This page encountered an error. Please refresh or contact support.'}
          </p>
          <button type="button" onClick={() => this.setState({ hasError: false, error: undefined })}>
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
